import { InputAdornment } from "@mui/material";
import { getCurrencySymbol } from "Utils/CurrencyUtils";

type Props = {
  currencyCode: string | undefined;
};

export const CurrencyAdornment = ({ currencyCode }: Props) => (
  <InputAdornment position="end">
    {currencyCode ? getCurrencySymbol(currencyCode) : ""}
  </InputAdornment>
);
